import React, { ChangeEvent } from 'react';
import { BannerPlaceType } from '@api/graphql/types';

interface Props {
    name: string;
    value: BannerPlaceType;
    placeholder?: string;
    hint?: string;
    onChangeHandler: (value: BannerPlaceType, name: string) => void;
}

interface State {
    value: BannerPlaceType;
}

class BannerPlaceTypeSelect extends React.Component<Props, State> {

    public state = {
        value: BannerPlaceType.BANNER,
    };

    public componentDidMount() {
        this.setState({value: this.props.value});
    }

    public componentWillReceiveProps(props: Props) {
        this.setState({value: props.value});
    }

    public render() {
        return (
            <>
                <select
                    name={this.props.name}
                    value={this.state.value}
                    onChange={(e: ChangeEvent<HTMLSelectElement>) => { this.props.onChangeHandler((e.currentTarget.value as BannerPlaceType), this.props.name); }}
                    className="form-control"
                >
                    <option value="BANNER">Banner</option>
                    <option value="SLIDER">Slider</option>
                </select>
                {this.props.hint && <span className="form-text m-b-none">{this.props.hint}</span>}
            </>
        );
    }
}

export default BannerPlaceTypeSelect;



// WEBPACK FOOTER //
// ./src/components/Form/BannerPlaceTypeSelect.tsx